import { useCallback } from "react";
import * as yup from "yup";

export const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup
        .string()
        .required("Email is required")
        .email("Email is not correctly formatted.   "),
    phone: yup
        .string()
        .required("Phone is required")
        .matches(
            /^[0-9]{10}$/,
            "Please enter 10 digit phone number without spaces."
        ),
    taxExemption: yup.boolean(),
    addressLineOne: yup.string().when("taxExemption", {
        is: (taxExemption) => taxExemption,
        then: yup.string().required("Address Line One is required"),
    }),
    city: yup.string().when("taxExemption", {
        is: (taxExemption) => taxExemption,
        then: yup.string().required("City is required"),
    }),
    state: yup.string().when("taxExemption", {
        is: (taxExemption) => taxExemption,
        then: yup.string().required("State is required"),
    }),
    pincode: yup.string().when("taxExemption", {
        is: (taxExemption) => taxExemption,
        then: yup
            .string()
            .matches(/^[0-9]{6}$/, "Incorrect Pincode format entered")
            .required("Pincode is required"),
    }),
    pancard: yup.string().when("taxExemption", {
        is: (taxExemption) => taxExemption,
        then: yup
            .string()
            .matches(
                /(^$|^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]$)/,
                "Incorrect Pancard format entered"
            )
            .required("Pancard is required"),
    }),
    dateOfBirth: yup.string().when("taxExemption", {
        is: (taxExemption) => taxExemption,
        then: yup.string().required("Date of birth is required"),
    }),
    // referenceCode: yup
    //     .string()
    //     .test(
    //         "Unique Email",
    //         "Incorrect Reference Code. Please check code again.",
    //         function (value) {
    //             return new Promise((resolve, reject) => {
    //                 axios
    //                     .post(
    //                         `${process.env.REACT_APP_BACKEND_URL}/validate/reference-code`,
    //                         {
    //                             code: value,
    //                         }
    //                     )
    //                     .then((res) => {
    //                         if (res.data.message === "not found") {
    //                             resolve(false);
    //                         }
    //                         resolve(true);
    //                     })
    //                     .catch((err) => console.log(err));
    //             });
    //         }
    //     ),
});

export const useYupValidationResolver = (validationSchema) =>
    useCallback(
        async (data) => {
            try {
                const values = await validationSchema.validate(data, {
                    abortEarly: false,
                });

                return {
                    values,
                    errors: {},
                };
            } catch (errors) {
                return {
                    values: {},
                    errors: errors.inner.reduce(
                        (allErrors, currentError) => ({
                            ...allErrors,
                            [currentError.path]: {
                                type: currentError.type ?? "validation",
                                message: currentError.message,
                            },
                        }),
                        {}
                    ),
                };
            }
        },
        [validationSchema]
    );
